var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSei(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_64)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_205_64",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 78
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78 0H0V78H78V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_205_64)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9999 1C59.9867 1 77 18.0132 77 38.9999C77 59.9867 59.9867 77 38.9999 77C18.0132 77 1 59.9867 1 38.9999C1 18.0132 18.0132 1 38.9999 1Z",
    fill: "url(#paint0_linear_205_64)",
    stroke: "#00F3AB",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_205_64",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 39,
    height: 39
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4405 58.88C50.1772 58.88 58.881 50.1764 58.881 39.44C58.881 28.7036 50.1772 20 39.4405 20C28.7038 20 20 28.7036 20 39.44C20 50.1764 28.7038 58.88 39.4405 58.88Z",
    fill: "#31E2B8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_205_64)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3751 48.9925C57.9699 46.1713 58.8801 42.912 58.8801 39.44C58.8801 34.804 57.2572 30.5469 54.5485 27.206L55.345 28.2764L51.9997 30.7656C48.5757 33.3134 43.8014 32.965 40.7836 29.9473C39.4148 28.5785 37.2033 28.554 35.8045 29.892L31.8219 33.7013L28.3382 30.0591L32.3207 26.2498C35.6995 23.0179 41.0412 23.0773 44.3474 26.3834C45.5968 27.6327 47.5734 27.7769 48.9909 26.7222L51.9252 24.5387C48.5477 21.7058 44.1929 20 39.4396 20C29.8448 20 21.8734 26.9508 20.2865 36.0916L22.1046 35.8492C24.3736 35.5467 26.6765 36.0546 28.6077 37.2836L30.5316 38.5078C31.9221 39.3927 33.7153 39.3238 35.0338 38.3349L37.5795 36.4257C41.1219 33.7689 46.0706 34.0835 49.248 37.1674L53.4357 41.2318L49.9254 44.8485L45.7378 40.7841C44.3397 39.4272 42.1622 39.2888 40.6035 40.4578L38.0578 42.367C35.0612 44.6144 30.9859 44.7709 27.8258 42.76L25.9019 41.5357C24.972 40.944 23.8632 40.6994 22.7707 40.8451L20.0781 41.2041C20.4205 45.0104 21.86 48.5005 24.0781 51.3558L27.3578 48.8049C30.869 46.0741 35.8022 46.135 39.2449 48.9517C40.5281 50.0015 42.3448 50.0955 43.7295 49.1837L45.3501 48.1165C48.8009 45.844 53.3439 46.2179 56.3751 48.9925ZM53.3228 53.0482L53.0582 52.7915C51.7256 51.498 49.6731 51.3044 48.122 52.3258L46.5014 53.393C43.2754 55.5174 39.043 55.2985 36.0534 52.8525C34.4312 51.5252 32.1066 51.4965 30.4521 52.7834L27.6917 54.9303C30.955 57.409 35.0255 58.8801 39.4396 58.8801C44.8778 58.8801 49.7945 56.6472 53.3228 53.0482Z",
    fill: "#31E2B8"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_64",
    x1: 798.466,
    y1: 0.999913,
    x2: 7012.19,
    y2: 7601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F3AB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSei);
export default __webpack_public_path__ + "static/media/sei.a9475dbc5d263b2032f421ac5a150119.svg";
export { ForwardRef as ReactComponent };